import { getRegions } from "@Services/common";
import { DownOutlined } from "@ant-design/icons";
import { ArrowDownIcon } from "@t8891/icon";
import { useClickAway } from "ahooks";
import React, { useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";

const RegionSelect: React.FC<{
  style: any;
  value?: any;
  defaultText?: any;
  onChange?: (value: any) => void;
  placeholder?: string;
}> = ({ style, value, defaultText, placeholder = "請選擇購車地區", onChange }) => {
  const [text, setText] = useState(defaultText);
  const [show, setShow] = useState(false);
  const ref = useRef<any>(null);
  const [regionState, setRegions] = useState<any[]>([]);

  useClickAway(() => {
    setShow(false);
  }, ref);

  // 獲取地區數據
  const { data: regionsData } = useQuery(["getRegions"], async () => {
    const response = await getRegions({ type: "all" });
    const resdata = response?.data as any;
    if (response.status === 12000 && resdata) {
      const result = [] as any[];
      resdata?.parts?.forEach((i) => {
        const regions = [] as any;
        i?.regions?.forEach((idx) => {
          regions.push(resdata?.regions?.[idx]);
        });
        result.push({ name: i.name, regionsName: regions });
      });
      setRegions(result);
      return resdata.regions;
    }
    return [];
  });

  useEffect(() => {
    const active = regionsData?.find((item) => String(item.id) === String(value));
    if (active) {
      setText(active.name);
    }
  }, [value, regionsData]);

  return (
    <div
      className='relative border-1 border-solid border-[#bbb] h-32 leading-32 rounded-4 px-10 cursor-pointer'
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        setShow(true);
      }}
    >
      {text ? (
        <span className='text-[#333] font-normal text-16'>{text}</span>
      ) : (
        <span className='text-16 font-normal text-[#d4d4d4]'>{placeholder}</span>
      )}
      <div className='absolute right-12 -top-2 text-12 text-[#bbb]'>
        <DownOutlined />
      </div>
      {show && (
        <div
          ref={ref}
          style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 8px 20px 0px" }}
          className='absolute w-[500px] z-99 rounded-4 border-[#e8e8e8] border-solid  -bottom-[160px] -left-4 bg-[#fff] '
        >
          <div className='flex flex-col p-14'>
            {regionState?.map((item) => {
              return (
                <div className='flex gap-20 text-14'>
                  <span className='text-[#333] font-medium'>{item.name}</span>
                  {item.regionsName?.map((regionItem) => {
                    return (
                      <span
                        className={text === regionItem.name ? "text-[#3264ff]" : "text-[#999]"}
                        onClick={(e) => {
                          e.stopPropagation();
                          onChange?.(regionItem.id);
                          setText(regionItem.name);
                          setShow(false);
                        }}
                      >
                        {regionItem.name}
                      </span>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default RegionSelect;
